import { createReducer } from '../../helpers/reducers';

import { types } from '../../actions/events';

const initialState = [];

const handleEventsLatestSuccess = (state, action) => {
  const { data } = action.payload;
  return data.map(result => result.id);
};

const handlers = {
  [types.EVENTS_LATEST.SUCCESS]: handleEventsLatestSuccess,
};

const latest = createReducer(initialState, handlers);

export default latest;

export const getEventsLatest = state => state.events.latest;



// WEBPACK FOOTER //
// ./src/reducers/events/latest.js